/*
 * OPUS Tシャツ注文ビルダー
 * - 本体（1カ所目の印刷代）＋追加料金商品（2カ所目／3カ所目以降／白インク／本体／デザイン作成）を
 *   カートの「親子（ネスト）行」としてまとめて追加します。
 * - 価格はすべてShopifyのバリエーション価格から計算するので、表示とカートの金額が一致します。
 */
(() => {
  'use strict';

  const root = document.querySelector('[data-opus-tshirt]');
  if (!root) return;
  const mount = root.querySelector('[data-opus-builder]');
  let cfg;
  try {
    cfg = JSON.parse(root.querySelector('[data-opus-config]').textContent);
  } catch (e) {
    mount.innerHTML = '<p class="tb-err">注文フォームの読み込みに失敗しました。ページを再読み込みしてください。</p>';
    return;
  }

  /* ---------- 小さな道具 ---------- */
  const P = cfg.products || {};
  const SET_KEY = 'セット番号';
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const lines = (arr) => (arr || []).map((s) => String(s).replace(/<br\s*\/?>/gi, '').trim()).filter(Boolean);
  const fmt = (cents) => {
    const a = (cents || 0) / 100;
    const f = cfg.moneyFormat || '¥{{amount_no_decimals}}';
    return f
      .replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) =>
        /no_decimals/.test(k)
          ? Math.round(a).toLocaleString('ja-JP')
          : a.toLocaleString('ja-JP', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      )
      .replace(/<[^>]*>/g, '');
  };
  const fileSize = (b) => (b >= 1048576 ? (b / 1048576).toFixed(1) + 'MB' : Math.max(1, Math.round(b / 1024)) + 'KB');
  const fileExt = (name) => (name.split('.').pop() || '').toUpperCase().slice(0, 4);
  const clampInt = (v, min, max) => Math.min(max, Math.max(min, parseInt(v, 10) || 0));

  const positions = lines(cfg.positions);
  const swatches = {};
  lines(cfg.swatches).forEach((l) => {
    const m = l.match(/^(.+?)\s*[:：]\s*(#[0-9a-f]{3,8})$/i);
    if (m) swatches[m[1].trim()] = m[2];
  });
  const isDark = (hex) => {
    if (!hex) return false;
    let h = hex.replace('#', '');
    if (h.length === 3) h = h.split('').map((c) => c + c).join('');
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(h.substr(i, 2), 16) / 255);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b < 0.45;
  };
  const acceptList = (cfg.accept || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  const acceptLabel = acceptList.map((s) => s.replace('.', '').toUpperCase()).filter((s) => s !== 'JPEG').join('・');

  /* ---------- 商品・バリエーション ---------- */
  const RE_TIER = /数量|枚数|区分|tier/i;
  const RE_COLOR = /色|カラー|colou?r/i;
  const RE_SIZE = /サイズ|size/i;
  const optIndex = (prod, re) => (prod ? prod.options.findIndex((n) => re.test(n)) : -1);

  /** 商品からバリエーションを選ぶ。want は {オプション位置: 値}、tier は数量区分の番号 */
  function pick(prod, want, tier) {
    if (!prod) return null;
    const ti = optIndex(prod, RE_TIER);
    return (
      prod.variants.find((v) =>
        prod.options.every((name, i) => {
          if (i === ti) {
            const vals = prod.optionValues[i];
            return v.options[i] === vals[Math.min(tier, vals.length - 1)];
          }
          if (want && want[i] != null) return v.options[i] === want[i];
          return true;
        })
      ) || null
    );
  }
  const unit = (prod, tier, want) => {
    const v = pick(prod, want, tier);
    return v ? v.price : 0;
  };

  const tierMins = (cfg.tierMins || [1]).map(Number).filter((n) => n > 0);
  const tierOf = (n) => tierMins.reduce((t, m, i) => (n >= m ? i : t), 0);
  const tierLabel = (t) => (tierMins[t + 1] ? `${tierMins[t]}〜${tierMins[t + 1] - 1}枚` : `${tierMins[t]}枚以上`);

  const body = P.body;
  const ci = optIndex(body, RE_COLOR);
  const si = optIndex(body, RE_SIZE);
  const colors = body && ci >= 0 ? body.optionValues[ci] : [];
  const sizes = body && si >= 0 ? body.optionValues[si] : body ? ['フリー'] : [];

  let maxLoc = Math.max(1, cfg.maxLocations || 6);
  if (!P.print2) maxLoc = 1;
  else if (!P.print3) maxLoc = Math.min(maxLoc, 2);

  /* ---------- 状態 ---------- */
  let uid = 0;
  const nextPosition = () => positions.find((p) => !state.locs.some((l) => l.pos === p)) || positions[0] || '';
  const state = {
    body: !!body,
    color: colors[0] || '',
    sizes: Object.fromEntries(sizes.map((s) => [s, 0])),
    bring: 1,
    locs: [],
    white: false,
    design: false,
    designNote: '',
    note: '',
    agree: false,
  };
  if (sizes.length) state.sizes[sizes.includes('M') ? 'M' : sizes[0]] = 1;
  state.locs.push({ id: ++uid, pos: positions[0] || '', file: null, url: null });

  const qty = () => (state.body ? sizes.reduce((s, k) => s + (state.sizes[k] || 0), 0) : state.bring);
  const colorWant = () => (ci >= 0 ? { [ci]: state.color } : {});
  const bodyWant = (size) => {
    const w = colorWant();
    if (si >= 0) w[si] = size;
    return w;
  };

  /** 1枚あたりの単価（デザイン料を除く）。本体はサイズ間で同額の前提で、選択中カラーの最初のサイズを使う */
  function perShirt(t) {
    const L = state.locs.length;
    let c = unit(P.main, t);
    if (L >= 2) c += unit(P.print2, t);
    if (L >= 3) c += unit(P.print3, t) * (L - 2);
    if (state.white) c += unit(P.white, t) * L;
    if (state.body && sizes.length) {
      const sz = sizes.find((k) => state.sizes[k] > 0) || sizes[0];
      c += unit(body, t, bodyWant(sz));
    }
    return c;
  }

  function calc() {
    const N = qty();
    const t = tierOf(Math.max(N, 1));
    const L = state.locs.length;
    const rows = [];
    const missing = [];
    const add = (key, label, prod, want, q, qtyText) => {
      if (q <= 0) return;
      const v = pick(prod, want, key === 'design' ? 0 : t);
      if (!v) {
        missing.push(label);
        return;
      }
      rows.push({ key, label, v, q, qtyText, total: v.price * q });
    };
    add('main', '印刷代（1カ所目）', P.main, null, N, `${N}枚`);
    if (L >= 2) add('print2', '印刷代（2カ所目）', P.print2, null, N, `${N}枚`);
    if (L >= 3) add('print3', '印刷代（3カ所目以降）', P.print3, null, N * (L - 2), `${N}枚 × ${L - 2}カ所`);
    if (state.white) add('white', '白インク', P.white, null, N * L, `${N}枚 × ${L}カ所`);
    if (state.body) {
      sizes.forEach((sz) => {
        const q = state.sizes[sz] || 0;
        if (q > 0) add('body', `Tシャツ本体（${[state.color, sz].filter(Boolean).join('・')}）`, body, bodyWant(sz), q, `${q}枚`);
      });
    }
    if (state.design) add('design', 'デザイン作成', P.design, null, 1, '1式');
    const total = rows.reduce((s, r) => s + r.total, 0);
    const designTotal = rows.filter((r) => r.key === 'design').reduce((s, r) => s + r.total, 0);
    return { N, t, L, rows, total, missing, per: N ? Math.round((total - designTotal) / N) : 0 };
  }

  /* ---------- 画面の組み立て ---------- */
  const stepper = (key, value, min, label) => `
    <div class="tb-stepper" data-stepper="${esc(key)}">
      <button type="button" class="tb-stepper__btn" data-dec aria-label="${esc(label)}を1枚減らす">−</button>
      <input class="tb-stepper__input" type="number" inputmode="numeric" min="${min}" max="999" value="${value}" aria-label="${esc(label)}の枚数" data-min="${min}">
      <button type="button" class="tb-stepper__btn" data-inc aria-label="${esc(label)}を1枚増やす">＋</button>
    </div>`;

  let stepNo = 0;
  const head = (title, id, meta) => `
    <div class="tb-step__head">
      <span class="tb-step__no" aria-hidden="true">${++stepNo}</span>
      <h2 class="tb-step__title" id="${id}">${title}</h2>
      ${meta ? `<span class="tb-step__meta">${meta}</span>` : ''}
    </div>`;

  function stepBody() {
    if (!body) {
      return `<section class="tb-step" aria-labelledby="tb-h-qty">${head('枚数', 'tb-h-qty')}
        <div class="tb-field">${stepper('bring', state.bring, 1, '枚数')}</div></section>`;
    }
    const sw = colors.map((c) => `<option value="${esc(c)}" ${c === state.color ? 'selected' : ''}>${esc(c)}</option>`).join('');
    const sz = sizes
      .map((s) => `<div class="tb-size" data-size-row="${esc(s)}"><span class="tb-size__name">${esc(s)}</span>${stepper('size:' + s, state.sizes[s], 0, s + 'サイズ')}<span class="tb-size__na" hidden>在庫なし</span></div>`)
      .join('');
    return `
    <section class="tb-step" aria-labelledby="tb-h-body">
      ${head('Tシャツ本体', 'tb-h-body')}
      <div class="tb-choice" role="radiogroup" aria-labelledby="tb-h-body">
        <label class="tb-opt">
          <input type="radio" name="tb-body" value="1" ${state.body ? 'checked' : ''} class="tb-sr">
          <span class="tb-opt__title">本体も注文する</span>
          <span class="tb-opt__meta">+<span data-body-unit></span>／枚</span>
        </label>
        <label class="tb-opt">
          <input type="radio" name="tb-body" value="0" ${state.body ? '' : 'checked'} class="tb-sr">
          <span class="tb-opt__title">持ち込み（印刷のみ）</span>
          <span class="tb-opt__meta">本体代なし</span>
        </label>
      </div>
      <div data-when="body">
        ${colors.length ? `<label class="tb-field"><span class="tb-label">カラー</span><span class="tb-select tb-select--color"><span class="tb-color-dot" data-color-dot aria-hidden="true"></span><select class="tb-input" data-color>${sw}</select></span></label>` : ''}
        <div class="tb-field">
          <span class="tb-label">サイズと枚数</span>
          <div class="tb-sizes">${sz}</div>
          <p class="tb-help">サイズごとに枚数を入れてください。カラーとデザインは全サイズ共通です。</p>
        </div>
      </div>
      <div data-when="bring" hidden>
        ${cfg.bringNote ? `<p class="tb-note">${esc(cfg.bringNote)}</p>` : ''}
        <div class="tb-field"><span class="tb-label">枚数</span>${stepper('bring', state.bring, 1, 'お持ち込み')}</div>
      </div>
      <p class="tb-err" data-err="qty" hidden></p>
    </section>`;
  }

  function stepPrint() {
    return `
    <section class="tb-step" aria-labelledby="tb-h-print">
      ${head('印刷箇所とデザインデータ', 'tb-h-print')}
      ${cfg.printNote ? `<p class="tb-help">${esc(cfg.printNote)}</p>` : ''}
      <ol class="tb-locs" data-locs></ol>
      <button type="button" class="tb-add" data-add-loc>
        <span class="tb-add__plus" aria-hidden="true">＋</span>
        <span class="tb-add__text">印刷箇所を追加</span>
        <span class="tb-add__price" data-add-price></span>
      </button>
      <details class="tb-table">
        <summary>料金表を見る</summary>
        <div class="tb-table__scroll">${priceTable()}</div>
      </details>
    </section>`;
  }

  function priceTable() {
    const rowsDef = [
      ['1カ所目', (t) => unit(P.main, t), ''],
      P.print2 && ['2カ所目', (t) => unit(P.print2, t), '+'],
      P.print3 && ['3カ所目以降（1カ所ごと）', (t) => unit(P.print3, t), '+'],
      P.white && ['白インク（1カ所ごと）', (t) => unit(P.white, t), '+'],
      body && ['Tシャツ本体', (t) => unit(body, t, bodyWant(sizes[0])), '+'],
    ].filter(Boolean);
    const ths = tierMins.map((m, t) => `<th scope="col">${esc(tierLabel(t))}</th>`).join('');
    const trs = rowsDef
      .map(([label, fn, sign]) => `<tr><th scope="row">${esc(label)}</th>${tierMins.map((m, t) => `<td>${sign}${fmt(fn(t))}</td>`).join('')}</tr>`)
      .join('');
    const design = P.design ? `<p class="tb-help">デザイン作成：${fmt(unit(P.design, 0))}（1注文あたり）</p>` : '';
    return `<table><thead><tr><th scope="col">1枚あたり（税込）</th>${ths}</tr></thead><tbody>${trs}</tbody></table>${design}`;
  }

  function stepWhite() {
    if (!P.white) return '';
    return `
    <section class="tb-step" aria-labelledby="tb-h-white">
      ${head('白インク', 'tb-h-white')}
      <label class="tb-check">
        <input type="checkbox" data-white ${state.white ? 'checked' : ''} class="tb-sr">
        <span class="tb-check__box" aria-hidden="true"></span>
        <span class="tb-check__body">
          <span class="tb-check__title">白インクを使って印刷する</span>
          <span class="tb-check__meta">+<span data-white-unit></span> × 印刷箇所数／枚${cfg.leadWhite ? `・納期 ${esc(cfg.leadWhite)}` : ''}</span>
        </span>
      </label>
      ${cfg.whiteNote ? `<p class="tb-note">${esc(cfg.whiteNote)}</p>` : ''}
      <p class="tb-warn" data-dark-warn hidden></p>
    </section>`;
  }

  function stepDesign() {
    if (!P.design) return '';
    return `
    <section class="tb-step" aria-labelledby="tb-h-design">
      ${head('デザイン作成', 'tb-h-design')}
      <label class="tb-check">
        <input type="checkbox" data-design ${state.design ? 'checked' : ''} class="tb-sr">
        <span class="tb-check__box" aria-hidden="true"></span>
        <span class="tb-check__body">
          <span class="tb-check__title">デザイン作成を依頼する</span>
          <span class="tb-check__meta">+${fmt(unit(P.design, 0))}（1注文あたり）</span>
        </span>
      </label>
      <div data-when="design" hidden>
        <label class="tb-field">
          <span class="tb-label">ご要望</span>
          <textarea class="tb-input" rows="4" data-design-note placeholder="例：チーム名「HAKODATE RC」を胸に。紺と白でシンプルに。">${esc(state.designNote)}</textarea>
        </label>
        ${cfg.designHelp ? `<p class="tb-help">${esc(cfg.designHelp)}</p>` : ''}
        <p class="tb-err" data-err="design" hidden></p>
      </div>
    </section>`;
  }

  function stepSummary() {
    return `
    <section class="tb-step tb-summary" aria-labelledby="tb-h-sum" data-summary>
      ${head('ご注文内容', 'tb-h-sum')}
      <dl class="tb-lines" data-lines></dl>
      <div class="tb-total">
        <span>合計<small>（税込）</small></span>
        <strong data-total aria-live="polite"></strong>
      </div>
      <p class="tb-per" data-per></p>
      <p class="tb-nudge" data-nudge hidden></p>
      <p class="tb-lead" data-lead hidden></p>
      <label class="tb-field">
        <span class="tb-label">備考（任意）</span>
        <textarea class="tb-input" rows="3" data-note placeholder="希望納期、印刷サイズのご希望など">${esc(state.note)}</textarea>
      </label>
      ${cfg.agreeText ? `
      <label class="tb-check tb-check--agree">
        <input type="checkbox" data-agree ${state.agree ? 'checked' : ''} class="tb-sr">
        <span class="tb-check__box" aria-hidden="true"></span>
        <span class="tb-check__body"><span class="tb-check__text">${esc(cfg.agreeText)}</span></span>
      </label>
      <p class="tb-err" data-err="agree" hidden></p>` : ''}
      <div class="tb-err tb-err--box" data-err="global" role="alert" hidden></div>
      <button type="button" class="opus-btn opus-btn--solid tb-cta" data-submit>カートに追加する</button>
      <p class="tb-help tb-center">ご注文後、データを確認してから制作に入ります。</p>
    </section>`;
  }

  function render() {
    stepNo = 0;
    mount.innerHTML = `
      <div class="tb">
        ${stepBody()}
        ${stepPrint()}
        ${stepWhite()}
        ${stepDesign()}
        ${stepSummary()}
      </div>
      <div class="tb-bar" data-bar>
        <div class="tb-bar__sum"><span class="tb-bar__label">合計（税込）</span><strong data-bar-total></strong><span class="tb-bar__sub" data-bar-sub></span></div>
        <button type="button" class="opus-btn opus-btn--solid tb-bar__btn" data-goto-summary>内容を確認</button>
      </div>
      ${cfg.designMode ? adminNotice() : ''}`;
    renderLocs();
    update();
    watchSummary();
  }

  function adminNotice() {
    const need = [['print2', '2カ所目の印刷代'], ['print3', '3カ所目以降の印刷代'], ['white', '白インク'], ['body', 'Tシャツ本体'], ['design', 'デザイン作成']]
      .filter(([k]) => !P[k])
      .map(([, l]) => l);
    if (!need.length) return '';
    return `<p class="tb-admin">【管理者向け・エディタ内のみ表示】未設定の商品：${need.join('、')}。セクション設定で商品を選ぶと、その項目が表示されます。</p>`;
  }

  /* ---------- 印刷箇所 ---------- */
  const locPriceLabel = (i, t) => {
    if (i === 0) return fmt(unit(P.main, t)) + '／枚';
    if (i === 1) return '+' + fmt(unit(P.print2, t)) + '／枚';
    return '+' + fmt(unit(P.print3, t)) + '／枚';
  };

  function dropHTML(l, i) {
    const label = state.design ? '参考画像を選択（任意）' : 'デザインデータを選択';
    if (l.file) {
      const thumb = l.url ? `<img src="${l.url}" alt="">` : `<span class="tb-file__ext">${esc(fileExt(l.file.name))}</span>`;
      return `
        <div class="tb-file">
          <div class="tb-file__thumb">${thumb}</div>
          <div class="tb-file__meta">
            <span class="tb-file__name">${esc(l.file.name)}</span>
            <span class="tb-file__size">${fileSize(l.file.size)}</span>
          </div>
          <label class="tb-file__btn">変更<input type="file" class="tb-sr" accept="${esc(cfg.accept)}" data-file="${l.id}" aria-label="印刷箇所${i + 1}のデータを変更"></label>
          <button type="button" class="tb-file__btn tb-file__btn--ghost" data-clear-file="${l.id}" aria-label="印刷箇所${i + 1}のデータを取り消す">取消</button>
        </div>`;
    }
    return `
      <label class="tb-drop" data-drop="${l.id}">
        <input type="file" class="tb-sr" accept="${esc(cfg.accept)}" data-file="${l.id}" aria-label="印刷箇所${i + 1}の${label}">
        <span class="tb-drop__icon" aria-hidden="true"></span>
        <span class="tb-drop__main">${label}</span>
        <span class="tb-drop__sub">ここにドラッグ＆ドロップもできます／${esc(acceptLabel)}・${cfg.maxFileMB || 20}MBまで</span>
      </label>`;
  }

  function renderLocs() {
    const list = mount.querySelector('[data-locs]');
    const many = state.locs.length > 1;
    list.innerHTML = state.locs
      .map((l, i) => `
        <li class="tb-loc" data-loc="${l.id}">
          <div class="tb-loc__head">
            <span class="tb-loc__title">印刷箇所 ${i + 1}</span>
            <span class="tb-loc__price" data-loc-price="${i}"></span>
            ${many ? `<button type="button" class="tb-loc__del" data-del-loc="${l.id}" aria-label="印刷箇所${i + 1}を削除">削除</button>` : ''}
          </div>
          <label class="tb-field tb-field--row">
            <span class="tb-label">印刷位置</span>
            <span class="tb-select"><select class="tb-input" data-pos="${l.id}">${positions.map((p) => `<option ${p === l.pos ? 'selected' : ''}>${esc(p)}</option>`).join('')}</select></span>
          </label>
          ${dropHTML(l, i)}
          <p class="tb-err" data-err-loc="${l.id}" hidden></p>
        </li>`)
      .join('');
  }

  function setFile(id, file) {
    const l = state.locs.find((x) => x.id === id);
    if (!l) return;
    const errEl = mount.querySelector(`[data-err-loc="${id}"]`);
    if (file) {
      const ext = '.' + (file.name.split('.').pop() || '').toLowerCase();
      if (acceptList.length && !acceptList.includes(ext)) {
        return showErr(errEl, `${acceptLabel}のファイルを選んでください。`);
      }
      if (file.size > (cfg.maxFileMB || 20) * 1048576) {
        return showErr(errEl, `ファイルが大きすぎます（${fileSize(file.size)}）。${cfg.maxFileMB || 20}MB以下にするか、備考欄に「別途送付」とご記入ください。`);
      }
    }
    if (l.url) URL.revokeObjectURL(l.url);
    l.file = file || null;
    l.url = file && /^image\/(png|jpe?g|gif|webp)$/.test(file.type) ? URL.createObjectURL(file) : null;
    renderLocs();
    update();
  }

  /* ---------- 表示の更新 ---------- */
  function showErr(el, msg) {
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  function update() {
    const c = calc();
    const $ = (sel) => mount.querySelector(sel);

    // 表示の切り替え
    mount.querySelectorAll('[data-when="body"]').forEach((el) => (el.hidden = !state.body));
    mount.querySelectorAll('[data-when="bring"]').forEach((el) => (el.hidden = state.body));
    mount.querySelectorAll('[data-when="design"]').forEach((el) => (el.hidden = !state.design));

    // 単価ラベル
    if ($('[data-body-unit]')) $('[data-body-unit]').textContent = fmt(unit(body, c.t, bodyWant(sizes[0])));
    if ($('[data-white-unit]')) $('[data-white-unit]').textContent = fmt(unit(P.white, c.t));
    mount.querySelectorAll('[data-loc-price]').forEach((el) => (el.textContent = locPriceLabel(+el.dataset.locPrice, c.t)));
    if ($('[data-color-dot]')) $('[data-color-dot]').style.setProperty('--sw', swatches[state.color] || '#dddddd');

    // サイズの在庫
    if (body) {
      sizes.forEach((sz) => {
        const row = mount.querySelector(`[data-size-row="${CSS.escape(sz)}"]`);
        if (!row) return;
        const v = pick(body, bodyWant(sz), c.t);
        const ok = !!(v && v.available);
        row.classList.toggle('is-na', !ok);
        row.querySelector('.tb-size__na').hidden = ok;
        row.querySelectorAll('input,button').forEach((el) => (el.disabled = !ok));
        if (!ok && state.sizes[sz]) {
          state.sizes[sz] = 0;
          row.querySelector('input').value = 0;
        }
      });
    }

    // 追加ボタン
    const addBtn = $('[data-add-loc]');
    const L = state.locs.length;
    if (addBtn) {
      const full = L >= maxLoc;
      addBtn.disabled = full;
      addBtn.querySelector('.tb-add__text').textContent = full ? `印刷箇所は${maxLoc}カ所までです` : '印刷箇所を追加';
      addBtn.querySelector('[data-add-price]').textContent = full ? '' : locPriceLabel(L, c.t);
    }

    // 濃色の注意
    const warn = $('[data-dark-warn]');
    if (warn) {
      const dark = state.body && isDark(swatches[state.color]);
      warn.hidden = !(dark && !state.white);
      warn.textContent = `「${state.color}」は濃い色のため、白インクの使用をおすすめします。`;
    }

    // 明細
    $('[data-lines]').innerHTML = c.rows
      .map((r) => `<div class="tb-line"><dt>${esc(r.label)}<span>${fmt(r.v.price)} × ${esc(r.qtyText)}</span></dt><dd>${fmt(r.total)}</dd></div>`)
      .join('') || '<div class="tb-line"><dt>枚数を入れてください</dt><dd>—</dd></div>';
    $('[data-total]').textContent = fmt(c.total);
    $('[data-per]').textContent = c.N ? `${c.N}枚・1枚あたり ${fmt(c.per)}${state.design ? '（デザイン作成を除く）' : ''}・価格区分 ${tierLabel(c.t)}` : '';

    const nudge = $('[data-nudge]');
    if (c.N && c.t < tierMins.length - 1) {
      const need = tierMins[c.t + 1] - c.N;
      const diff = perShirt(c.t) - perShirt(c.t + 1);
      nudge.hidden = !(diff > 0);
      nudge.textContent = `あと${need}枚で、1枚あたり${fmt(diff)}安くなります（${tierLabel(c.t + 1)}の価格）`;
    } else {
      nudge.hidden = true;
    }

    const lead = $('[data-lead]');
    const leadText = state.white && cfg.leadWhite ? `納期の目安：${cfg.leadWhite}（白インク使用）` : cfg.leadNormal ? `納期の目安：${cfg.leadNormal}` : '';
    lead.textContent = leadText;
    lead.hidden = !leadText;

    $('[data-bar-total]').textContent = fmt(c.total);
    $('[data-bar-sub]').textContent = c.N ? `${c.N}枚・${L}カ所` : '';

    // 商品名の下の「〜円」
    const from = root.querySelector('[data-opus-from]');
    if (from && tierMins.length > 1) {
      const p0 = unit(P.main, 0);
      const pl = unit(P.main, tierMins.length - 1);
      if (pl && pl < p0) {
        from.innerHTML = `印刷1カ所 <strong>${fmt(p0)}</strong>／枚<span>（税込・本体代別）</span><em>${esc(tierLabel(tierMins.length - 1))}なら ${fmt(pl)}／枚</em>`;
      }
    }

    // 入力済みのエラーは直ったら消す
    if (c.N > 0) showErr($('[data-err="qty"]'), '');
    if (state.agree) showErr($('[data-err="agree"]'), '');
    state.locs.forEach((l) => {
      if (l.file || state.design) showErr(mount.querySelector(`[data-err-loc="${l.id}"]`), '');
    });
    return c;
  }

  /* ---------- 入力イベント ---------- */
  mount.addEventListener('click', (e) => {
    const t = e.target;
    const step = t.closest('[data-stepper]');
    if (step && (t.closest('[data-inc]') || t.closest('[data-dec]'))) {
      const input = step.querySelector('input');
      const min = +input.dataset.min || 0;
      input.value = clampInt(+input.value + (t.closest('[data-inc]') ? 1 : -1), min, 999);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    if (t.closest('[data-add-loc]')) {
      if (state.locs.length >= maxLoc) return;
      state.locs.push({ id: ++uid, pos: nextPosition(), file: null, url: null });
      renderLocs();
      update();
      const last = mount.querySelector('.tb-loc:last-child select');
      if (last) last.focus();
      return;
    }
    const del = t.closest('[data-del-loc]');
    if (del) {
      const id = +del.dataset.delLoc;
      const l = state.locs.find((x) => x.id === id);
      if (l && l.url) URL.revokeObjectURL(l.url);
      state.locs = state.locs.filter((x) => x.id !== id);
      renderLocs();
      update();
      const addBtn = mount.querySelector('[data-add-loc]');
      if (addBtn) addBtn.focus();
      return;
    }
    const clr = t.closest('[data-clear-file]');
    if (clr) {
      setFile(+clr.dataset.clearFile, null);
      return;
    }
    if (t.closest('[data-goto-summary]')) {
      mount.querySelector('[data-summary]').scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (t.closest('[data-submit]')) submit();
  });

  mount.addEventListener('change', (e) => {
    const t = e.target;
    if (t.name === 'tb-body') state.body = t.value === '1';
    else if (t.matches('[data-color]')) state.color = t.value;
    else if (t.matches('[data-white]')) state.white = t.checked;
    else if (t.matches('[data-design]')) {
      state.design = t.checked;
      renderLocs();
    } else if (t.matches('[data-agree]')) state.agree = t.checked;
    else if (t.matches('[data-pos]')) {
      const l = state.locs.find((x) => x.id === +t.dataset.pos);
      if (l) l.pos = t.value;
    } else if (t.matches('[data-file]')) {
      setFile(+t.dataset.file, t.files && t.files[0]);
      return;
    } else if (t.closest('[data-stepper]')) {
      const key = t.closest('[data-stepper]').dataset.stepper;
      const min = +t.dataset.min || 0;
      const v = clampInt(t.value, min, 999);
      t.value = v;
      if (key === 'bring') state.bring = v;
      else if (key.startsWith('size:')) state.sizes[key.slice(5)] = v;
    }
    update();
  });

  mount.addEventListener('input', (e) => {
    const t = e.target;
    if (t.matches('[data-design-note]')) state.designNote = t.value;
    else if (t.matches('[data-note]')) state.note = t.value;
    else if (t.closest('[data-stepper]') && t.value !== '') {
      t.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  ['dragenter', 'dragover'].forEach((ev) =>
    mount.addEventListener(ev, (e) => {
      const d = e.target.closest('[data-drop]');
      if (!d) return;
      e.preventDefault();
      d.classList.add('is-over');
    })
  );
  ['dragleave', 'drop'].forEach((ev) =>
    mount.addEventListener(ev, (e) => {
      const d = e.target.closest('[data-drop]');
      if (!d) return;
      e.preventDefault();
      d.classList.remove('is-over');
      if (ev === 'drop' && e.dataTransfer && e.dataTransfer.files[0]) setFile(+d.dataset.drop, e.dataTransfer.files[0]);
    })
  );

  /* スマホ下部の合計バー：注文内容が見えている間は隠す */
  function watchSummary() {
    const bar = mount.querySelector('[data-bar]');
    const sum = mount.querySelector('[data-summary]');
    if (!('IntersectionObserver' in window) || !bar || !sum) return;
    new IntersectionObserver((entries) => {
      entries.forEach((en) => bar.classList.toggle('is-hidden', en.isIntersecting));
    }, { rootMargin: '0px 0px -40% 0px' }).observe(sum);
  }

  /* 商品画像の切り替え */
  root.addEventListener('click', (e) => {
    const th = e.target.closest('.opus-pdp__thumb');
    if (!th) return;
    const img = root.querySelector('.opus-pdp__img');
    if (img && img.tagName === 'IMG') {
      img.removeAttribute('srcset');
      img.src = th.dataset.src;
    }
    root.querySelectorAll('.opus-pdp__thumb').forEach((b) => b.classList.toggle('is-active', b === th));
  });

  /* ---------- 注文前チェック ---------- */
  function validate(c) {
    const errs = [];
    const $ = (sel) => mount.querySelector(sel);
    if (c.N < 1) {
      showErr($('[data-err="qty"]'), state.body ? 'サイズごとの枚数を1枚以上入れてください。' : '枚数を1枚以上入れてください。');
      errs.push($('[data-err="qty"]'));
    }
    if (!state.design) {
      state.locs.forEach((l, i) => {
        if (!l.file) {
          const el = mount.querySelector(`[data-err-loc="${l.id}"]`);
          showErr(el, `印刷箇所${i + 1}のデザインデータを選んでください。`);
          errs.push(el);
        }
      });
    }
    if (state.design && !state.designNote.trim() && !state.locs.some((l) => l.file)) {
      const el = $('[data-err="design"]');
      showErr(el, 'ご要望を入力するか、参考画像をアップロードしてください。');
      errs.push(el);
    }
    if (cfg.agreeText && !state.agree) {
      const el = $('[data-err="agree"]');
      showErr(el, '確認事項に同意してください。');
      errs.push(el);
    }
    if (c.missing.length) errs.push('価格の設定が見つかりません（' + c.missing.join('、') + '）。お手数ですがお問い合わせください。');
    return errs;
  }

  function properties(c, ref) {
    const p = {};
    p[SET_KEY] = ref;
    p['枚数'] = `${c.N}枚`;
    if (state.body) {
      const bd = sizes.filter((s) => state.sizes[s] > 0).map((s) => `${s}×${state.sizes[s]}`).join('・');
      p['Tシャツ本体'] = `あり（${[state.color, bd].filter(Boolean).join('／')}）`;
    } else if (body) {
      p['Tシャツ本体'] = 'なし（お持ち込み）';
    }
    p['印刷箇所数'] = `${c.L}カ所`;
    state.locs.forEach((l, i) => {
      p[`印刷${i + 1} 位置`] = l.pos;
    });
    if (P.white) p['白インク'] = state.white ? 'あり' : 'なし';
    if (P.design) p['デザイン作成'] = state.design ? '依頼する' : 'なし';
    if (state.design && state.designNote.trim()) p['デザインのご要望'] = state.designNote.trim();
    if (state.note.trim()) p['備考'] = state.note.trim();
    p['注文時の見積額'] = fmt(c.total);
    return p;
  }

  function children(c, ref) {
    return c.rows
      .filter((r) => r.key !== 'main')
      .map((r) => ({ id: r.v.id, quantity: r.q, properties: { [SET_KEY]: ref } }));
  }

  const postJSON = (url, data) =>
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
  const errText = async (res) => {
    try {
      const j = await res.json();
      return j.description || j.message || '';
    } catch (e) {
      return '';
    }
  };

  async function submit() {
    const c = update();
    const gErr = mount.querySelector('[data-err="global"]');
    showErr(gErr, '');
    const errs = validate(c);
    if (errs.length) {
      const msgs = errs.filter((e) => typeof e === 'string');
      if (msgs.length) showErr(gErr, msgs.join(' '));
      const first = errs.find((e) => typeof e !== 'string') || gErr;
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const ref = 'T-' + Date.now().toString(36).slice(-4).toUpperCase() + Math.random().toString(36).slice(2, 4).toUpperCase();
    const props = properties(c, ref);
    const mainRow = c.rows.find((r) => r.key === 'main');
    const kids = children(c, ref);

    if (cfg.preview) {
      window.dispatchEvent(new CustomEvent('opus:preview-submit', { detail: { main: { id: mainRow.v.id, quantity: c.N, properties: props, files: state.locs.map((l, i) => l.file && `印刷${i + 1} データ: ${l.file.name}`).filter(Boolean) }, children: kids, total: c.total } }));
      return;
    }

    const btn = mount.querySelector('[data-submit]');
    btn.disabled = true;
    btn.textContent = 'カートに追加しています…';
    try {
      // 1) 本体：デザインファイルを含むので multipart で送る
      const fd = new FormData();
      fd.append('id', mainRow.v.id);
      fd.append('quantity', c.N);
      Object.entries(props).forEach(([k, v]) => fd.append(`properties[${k}]`, v));
      state.locs.forEach((l, i) => {
        if (l.file) fd.append(`properties[印刷${i + 1} データ]`, l.file, l.file.name);
      });
      const r1 = await fetch(cfg.cartAddUrl, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
      if (!r1.ok) throw new Error((await errText(r1)) || 'カートに追加できませんでした。');
      const j1 = await r1.json();
      const parent = j1.items ? j1.items[0] : j1;

      // 2) 追加料金：本体の子（ネスト行）として追加。対応していない場合は通常の行で追加
      if (kids.length) {
        let r2 = await postJSON(cfg.cartAddUrl, { items: kids.map((k) => Object.assign({ parent_line_key: parent.key }, k)) });
        if (!r2.ok) r2 = await postJSON(cfg.cartAddUrl, { items: kids });
        if (!r2.ok) {
          const msg = await errText(r2);
          await postJSON(cfg.cartChangeUrl, { id: parent.key, quantity: 0 });
          throw new Error(msg || 'オプションをカートに追加できませんでした。');
        }
      }
      window.location.href = cfg.cartUrl;
    } catch (err) {
      showErr(gErr, `${err.message} 時間をおいて再度お試しいただくか、お問い合わせください。`);
      btn.disabled = false;
      btn.textContent = 'カートに追加する';
    }
  }

  render();
})();
